import CustomButton from "common/components/Button/Button"
import { useTranslation } from "react-i18next"

import "./styles.scss"

// eslint-disable-next-line @typescript-eslint/no-empty-function
const CamposPersonalizadoBoardAddButton = ({ addEmptyLine = () => {} }) => {
  const { t } = useTranslation()
  return (
    <div className='campos-personalizados-board-add-button d-flex justify-content-center align-items-center h-100'>
      <CustomButton
        className='mr-2 btn-primary button-outline'
        label={t("inventario.articulos.modal.addPersonalField")}
        onClick={addEmptyLine}
      />
    </div>
  )
}

export default CamposPersonalizadoBoardAddButton
